<template>
	<v-card v-if="listUserInfos" elevation="0">
		<v-toolbar elevation="0" class="h-2 px-2 -mp-2">
			<span class="text-base"> {{ $t("label.user_selection") }} </span>
			<v-spacer></v-spacer>
			<v-btn icon x-small @click="close">
				<v-icon> mdi-close </v-icon>
			</v-btn>
		</v-toolbar>
		<v-divider></v-divider>
		<vue-perfect-scrollbar class="h-[75vh]">
			<v-card-text>
				<v-autocomplete
					:items="listOrganizations"
					label="Lựa chọn đơn vị"
					dense
					outlined
					clearable
					item-text="path"
					:item-value="(item) => item.id"
					v-model="selectedDeptId"
				>
				</v-autocomplete>
				<v-text-field
					maxLength="255"
					v-model="search"
					flat
					hide-details
					dense
					class="rounded-0 mx-2 my-2 elevation-0 text-xs"
					:no-data-text="$t('message.no_results')"
					@keyup="customFilter($event)"
					:placeholder="$t('title.search')"
					><template v-slot:[`prepend-inner`]>
						<v-icon size="16" class="mt-1.5"> mdi-magnify </v-icon>
					</template>
				</v-text-field>
				<v-data-table
					v-model="selected"
					:headers="headers"
					:items="listUserInfos"
					:single-select="singleSelect"
					item-key="id"
					show-select
					:no-data-text="$t('message.no_results')"
					:no-results-text="$t('message.no_results')"
					:server-items-length="countAllItem"
					@pagination="changePage($event)"
					fixed-header
					multi-sort
					height="100%"
					class="grey lighten-5 mt-4"
					:footer-props="{
						'items-per-page-options': [10, 20, 50, 100],
					}"
				>
					<template v-slot:[`item.ranks`]="{ item }">
						<div v-for="rank of item.ranks" :key="rank.id">
							<span
								v-if="
									rank.rankName && rank.rankName.length <= 25
								"
								class="text-xs"
							>
								{{ rank.rankName }}
							</span>
							<v-tooltip
								bottom
								v-if="
									rank.rankName && rank.rankName.length > 25
								"
							>
								<template v-slot:activator="{ on, attrs }">
									<span
										v-bind="attrs"
										v-on="on"
										class="text-xs"
									>
										{{ rank.rankName.slice(0, 25) }}
										...
									</span>
								</template>
								<span class="text-xs">
									{{ rank.rankName }}
								</span>
							</v-tooltip>
						</div>
					</template>
					<template v-slot:[`item.email`]="{ item }">
						<span
							v-if="item.email && item.email.length <= 25"
							class="text-xs"
						>
							{{ item.email }}
						</span>
						<v-tooltip
							bottom
							v-if="item.email && item.email.length > 25"
						>
							<template v-slot:activator="{ on, attrs }">
								<span v-bind="attrs" v-on="on" class="text-xs">
									{{ item.email.slice(0, 25) }}
									...
								</span>
							</template>
							<span class="text-xs">
								{{ item.email }}
							</span>
						</v-tooltip>
					</template>
					<template v-slot:[`item.organizations`]="{ item }">
						<span
							v-for="organization of item.organizations"
							:key="organization.id"
							v-bind="item"
						>
							<v-avatar color="red mr-2" size="24">
								<span class="white--text">
									{{
										getAvatarText(
											organization.organizationName,
											2,
										)
									}}
								</span>
							</v-avatar>
							{{ organization.organizationName }}
						</span>
					</template>
					<template
						v-for="header in headers.filter((header) =>
							header.hasOwnProperty('formatter'),
						)"
						v-slot:[`item.${header.value}`]="{ headers, value }"
					>
						{{ header.formatter(value) }}
					</template>

					<template v-slot:no-data>
						<h3>{{ $t("message.no_data") }}</h3>
					</template>
				</v-data-table>
			</v-card-text>
		</vue-perfect-scrollbar>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				elevation="0"
				color="blue darken-2"
				dark
				class="rounded-0"
				@click="Save"
			>
				{{ $t("button.ok") }}</v-btn
			>

			<v-btn
				elevation="0"
				color="grey lighten-4"
				class="rounded-0"
				@click="close"
			>
				{{ $t("button.cancel") }}</v-btn
			>
		</v-card-actions>
	</v-card>
</template>

<script>
import globalService from "@/services/global.service";
import moment from "moment";
import administratorAPI from "../../administrator/administrator.api";
import constant from "@/common/constant";
export default {
	name: "UserInfosRequestDataV2",
	props: ["stepDataId", "getUserForMailCTP", "isSingleSelect"],
	watch: {
		stepDataId() {
			this.search = "";
			this.searchUserByFilter();
		},
		selectedDeptId() {
			this.searchUserByFilter();
		},
	},
	data() {
		return {
			selectedDeptId: null,
			listOrganizations: [],
			dialogSelectBophan: false,
			listUserInfos: [],
			listUserInfosDefault: [],
			headers: [
				{
					text: this.$t("label.first_and_lastname"),
					value: "fullName",
					sortable: false,
					filter: (value) => {
						if (!this.search) return true;
						if (!value) return;
						return this.nonAccentVietnamese(value)
							.toLocaleUpperCase()
							.includes(
								this.nonAccentVietnamese(
									this.search,
								).toLocaleUpperCase(),
							);
					},
				},

				{
					text: this.$t("label.roleName"),
					value: "rankName",
				},
				{
					text: this.$t("label.email"),
					value: "email",
				},
				{
					text: this.$t("label.username"),
					value: "userName",
				},
				{
					text: this.$t("label.department"),
					value: "organizationName",
				},
			],
			items: [],
			search: "",
			singleSelect: false,
			selected: [],
			selected_tree: [],
			fullName: "",
			rankName: "",
			listOrganization: [],
			countAllItem: 0,
			filterExist: false,
			s_organizations: this.$t("label.show_all"),
			listBophan: [],
			objFilter: {
				fullName: "",
			},
			deptRoot: null,
		};
	},
	created() {
		this.getAllgetAllOrganizations();
		this.selectedDeptId = this.currentUserInfo?.organizations[0].id;
		this.singleSelect = this.isSingleSelect;
	},
	async mounted() {},

	methods: {
		async getAllgetAllOrganizations() {
			let response = await globalService.getData_Async(
				administratorAPI.API_GetllOrganizationWorkflow(),
			);

			if (!response || !response.state) {
				return;
			}
			this.listOrganizations = response.data.map((item) => {
				if (item.path) {
					item.path = item.path.replace(" - MOBIFONE", "");
				} else {
					item.path = item.organizationName;
				}
				return item;
			});
			this.deptRoot = this.listOrganizations.find(
				(el) => el.id === "TCT",
			);
		},
		close() {
			this.$emit("close", true);
		},

		customFilter(event) {
			if (
				event.code == constant.keys.enter ||
				event.keyCode == constant.keys.enter_keyCode
			) {
				this.searchUserByFilter();
			}
		},
		async Save() {
			if (this.selected.length == 0) {
				return this.toastError(this.$t("message.alert_no_selected"));
			}
			await this.$emit("save", this.selected);
			await this.$emit("close", true);
			this.selected = [];
		},
		async findUserInListBophan(item) {
			for (let i = 0; i < this.listUserInfos.length; i++) {
				for (
					let j = 0;
					j < this.listUserInfos[i].organizations.length;
					j++
				) {
					if (
						this.listUserInfos[i].organizations[j]
							.organizationName == item.organizationName
					) {
						item["children"].push({
							organizationName: this.listUserInfos[i].fullName,
							id: this.listUserInfos[i],
						});
					}
				}
			}
		},

		openDialog() {
			this.dialogSelectBophan = true;
		},
		sortList(arr) {
			return arr.sort((a, b) => {
				return (
					moment(b.createdDate).toDate().getTime() -
					moment(a.createdDate).toDate().getTime()
				);
			});
		},
		changePage(event) {
			if (
				this.search &&
				this.search !== null &&
				this.countAllItem / event.itemsPerPage < event.page - 1
			) {
				this.searchUserByFilter(
					0,
					event.itemsPerPage === -1
						? event.itemsLength
						: event.itemsPerPage,
				);
			} else {
				this.searchUserByFilter(
					event.page - 1,
					event.itemsPerPage === -1
						? event.itemsLength
						: event.itemsPerPage,
				);
			}
			// console.log("event", event);
			return;
		},
		async searchUserByFilter(
			page = constant.page,
			page_size = constant.page_size,
		) {
			this.objFilter = {
				fullName: this.search,
			};
			let response = null;
				response = await globalService.getData_Async(
					administratorAPI.GetUsersByStepData(
						this.stepDataId,
						this.search,
						page,
						page_size,
						this.selectedDeptId,
					),
				);
			if (!response || !response.state) {
				return;
			}
			this.countAllItem = response.data.total;
			this.listUserInfos = response.data?.listData.filter((entry) => {
				entry.showAll = false;
				return entry;
			});
			this.listUserInfos = this.sortList(this.listUserInfos);
		},
	},
};
</script>

<style lang="scss" scoped>
.test {
	display: flex;
	justify-content: space-between;
}

.w-40 {
	width: 200px !important;
}
</style>
